module.exports = __webpack_public_path__ + "static/media/logo.4ce0c5119dfe3d16a9ee00f5d8e3bf92ad44134da0cf00ad02726d000015968c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hive-logo/logo.svg
// module id = 822
// module chunks = 204